import { getService } from '@innovyze/lib_get_service';
import config from './config.api';

export const tilesBaseUrl = getService('tiles', config);
